import { DefaultTheme } from 'styled-components'

import {
  boticarioTheme,
  eudoraTheme,
  ouiTheme,
  eamTheme,
  grupoTheme,
} from '@grupoboticario/barril-del-chavo/dist/themes'

const selectTheme = (theme: string): DefaultTheme => {
  if (!theme) return grupoTheme
  switch (theme.toUpperCase()) {
    case 'EUD':
    case 'EUDORA':
      return eudoraTheme

    case 'BOT':
    case 'BOTICARIO':
      return boticarioTheme

    case 'OUI':
      return ouiTheme

    case 'EAM':
    case 'EUAMOMAKE':
      return eamTheme

    default:
      return grupoTheme
  }
}

export { selectTheme }
